import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import Header from '../../components/Header';
import { useTranslation } from '../../hooks/useTranslation';
import PrimaryButton from '../../components/PrimaryButton';
import FloatingActions from '../../components/FloatingActions';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../contexts/DataContext';
import { useFlow } from '../../contexts/FlowContext';

import NonLux from '../../assets/Group 1000005547.png';

function FinishPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, trackEvent, flowNumber } = useContext(DataContext);
  const { getBasePath } = useFlow();
  useEffect(() => {
    trackEvent({ nav_to_final_page: 1 });
    
  }, [trackEvent]);
  if (
    (flowNumber === 2 || flowNumber === 3) &&
    !data?.country?.includes('lux')
  ) {
    return (
      <Box
        sx={{
          displayl: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'space-between',
          gap: '0px',
          background: '#F6F4F0',
        }}
      >
        <Header />
        <div
          style={{
            marginInline: '24px',
            display: 'flex',
            flexDirection: 'column',
            padding: '22px',
            alignItems: 'center',
            background: 'white',
            borderRadius: '10px',
            marginTop: '66px',
          }}
        >
          <div
            style={{
              width: '135px',
              height: '77px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img src={NonLux} style={{ width: '105px', marginLeft: '30px' }} />
          </div>
          <Typography
            sx={{
              marginTop: '20px',
              fontSize: '24px',
              fontWeight: '700',
              lineHeight: '29px',
            }}
          >
            {t('finishPage.sorry')}
          </Typography>
          <Typography
            sx={{
              marginTop: '5px',
              fontSize: '16px',
              fontWeight: '500',
              lineHeight: '22px',
              opacity: '0.5',
              maxWidth: '200px',
              textAlign: 'center',
            }}
          >
            {t(
            data?.country?.includes('lux') 
                ? 'finishPage.description'
                : 'finishPage.descriptionNonResident'
            )}
          </Typography>
        </div>

        <FloatingActions childrenStyle={{}}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
              paddingInline: '24px',
            }}
          >
            <PrimaryButton
              style={{ flex: 1 }}
              onClick={() => {
                window.location.href = `${getBasePath()}/`;
              }}
            >
              {t('close')}
            </PrimaryButton>
          </div>
        </FloatingActions>
      </Box>
    );
  }
  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header />
      <div
        style={{
          marginInline: '24px',
          display: 'flex',
          flexDirection: 'column',
          padding: '22px',
          alignItems: 'center',
          background: 'white',
          borderRadius: '10px',
          marginTop: '66px',
        }}
      >
        <div
          style={{
            width: '66px',
            height: '69px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="66"
            height="69"
            viewBox="0 0 66 69"
            fill="none"
          >
            <path
              d="M63 31.5C63 48.897 48.897 63 31.5 63C14.103 63 0 48.897 0 31.5C0 14.103 14.103 7.99994 31.5 7.99994C48.897 7.99994 63 14.103 63 31.5Z"
              fill="#00D1D2"
            />
            <circle
              cx="31.5"
              cy="31.5"
              r="29"
              stroke="#44546A"
              stroke-width="5"
            />
            <circle cx="25" cy="17" r="4" fill="#44546A" />
            <circle cx="39" cy="17" r="4" fill="#44546A" />
            <path
              d="M39 27C33.6874 30.984 30.6373 31.0159 25 27"
              stroke="#44546A"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="49.5"
              cy="52.5"
              r="14.5"
              fill="#44546A"
              stroke="white"
              stroke-width="4"
            />
            <path
              d="M44 52.5001L47.8413 56.4287L55.5238 48.5715"
              stroke="white"
              stroke-width="4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <Typography
          sx={{
            marginTop: '20px',
            fontSize: '24px',
            fontWeight: '700',
            lineHeight: '29px',
          }}
        >
          {t('finishPage.title')}
        </Typography>
        <Typography
          sx={{
            marginTop: '5px',
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '22px',
            opacity: '0.5',
          }}
        >
          {t(
            data?.country?.includes('lux') 
              ? 'finishPage.description'
              : 'finishPage.descriptionNonResident'
          )}
        </Typography>
      </div>

      <FloatingActions childrenStyle={{}}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            paddingInline: '24px',
          }}
        >
          <PrimaryButton
            style={{ flex: 1 }}
            onClick={() => window.location.href=`${getBasePath()}/`}
          >
            {t('finish')}
          </PrimaryButton>
        </div>
      </FloatingActions>
    </Box>
  );
}

export default FinishPage;
